import React, { Component } from 'react';
import ReactSlick from 'react-slick';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ReactImageMagnify from 'react-image-magnify';

import ProductLabels from '../../../reusable-components/Labels/ProductLabels';
import * as overlayActions from '../overlayFull/overlayActions';
import * as galleryActions from './galleryActions';
import { addClass } from '../../utils/ie9polyfills';

import arrayToString from '../../../utils/js/arrayToString';

import './slick.less';

class SlickComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nav1: null,
      nav2: null,
      activeSlide: 0
    };

    this.slider1 = React.createRef();
    this.slider2 = React.createRef();
  }

  componentDidMount() {
    this.setState({
      nav1: this.slider1.current,
      nav2: this.slider2.current
    });

    if (this.slider1 && this.slider1.current.innerSlider) {
      this.slider1.current.innerSlider.list.setAttribute('tabindex', 0);
      this.slider1.current.innerSlider.list.focus();
    }

    this.props.REGISTER_SLIDER('desktopSlider', this.slider1.current);
  }

  handleFirstPicLoaded(i) {
    if (i === 0) {
      const footer = document.getElementById('pdp-footer');
      addClass(footer, 'showFooter');
    }
  }

  render() {
    const BFCondition = window.config.black_friday_ff;
    /**
     * The Discount Percentage, which determines if the Discount Label is shown. (10% or more)
     * @type {string}
     */
    const discountPercentage =
      this.props?.app?.data?.prices?.discount_percentage || '0';
    const {
      images,
      videos,
      // video_file,
      // video_thumbnail,
      title,
      labels
    } = this.props.app.data;
    const { selections } = this.props.app;
    const selectedLabels = selections.sizeDetails
      ? selections.sizeDetails.labels
      : labels;
    const { activeSlide } = this.state;
    const width = this.props.general.isSmallDesktop ? 430 : 490;
    const style = {
      position: 'relative',
      height: 0,
      width: '100%',
      paddingBottom: '50.25%',
      marginTop: '25%'
    };
    const totalGalleryLength =
      videos && videos.length > 0
        ? videos.length + images.gallery.length
        : images.gallery.length;
    return (
      <div className="slickComponent">
        {totalGalleryLength > 6 && activeSlide !== 0 && (
          <div
            className="arrow arrow-left"
            onClick={() => {
              this.slider1.current.slickPrev();
              this.slider2.current.slickPrev();
            }}
            role="button"
            tabIndex="0"
            aria-label="Previous Image"
            style={{ outline: 'none' }}
          />
        )}
        {totalGalleryLength > 6 && activeSlide !== totalGalleryLength - 1 && (
          <div
            className="arrow arrow-right"
            onClick={() => {
              this.slider1.current.slickNext();
              this.slider2.current.slickNext();
            }}
            role="button"
            tabIndex="0"
            aria-label="Next Image"
            style={{ outline: 'none' }}
          />
        )}
        <div
          className={
            totalGalleryLength > 6
              ? 'thumbSliderHolder'
              : 'thumbSliderHolder noArrows'
          }
        >
          <ReactSlick
            className="thumbSlider"
            asNavFor={this.state.nav1}
            ref={this.slider2}
            dots={false}
            infinite={false}
            arrows={false}
            speed={200}
            slidesToShow={6}
            swipeToSlide
            focusOnSelect
            vertical
            draggable
            accessibility={false}
            lazyLoad
          >
            {images.gallery.map((item, i) => {
              if (item.thumb !== '') {
                return (
                  <div
                    className={i === activeSlide ? 'thumb active' : 'thumb'}
                    key={item.thumb}
                    onClick={() => {
                      this.slider1.current.slickGoTo(i);
                      this.slider2.current.slickGoTo(i);
                    }}
                    role="button"
                    tabIndex="0"
                  >
                    <img src={item.thumb} alt={`thumb ${title}`} />
                    <div>
                      <span className="bar" />
                    </div>
                  </div>
                );
              }
              return null;
            })}
            {/* {video_file ? (
              <div
                id="product-video"
                className={
                activeSlide === images.gallery.length
                ? 'active thumb thumb-video'
                : 'thumb thumb-video'
              }
              >
                {video_thumbnail ? (
                  <img
                    className="thumbnail-video"
                    src={video_thumbnail}
                    alt="Product video thumbnail"
                  />
                )
                :
                (<div className="v-icon" />)
                }

                <div>
                  <span className="bar" />
                </div>
              </div>
              )
              :
              (<div />)
            } */}
            {videos && videos.length > 0 && (
              <div
                className={
                  activeSlide === images.gallery.length + 1
                    ? 'active thumb thumb-video'
                    : 'thumb thumb-video'
                }
              >
                <div className="v-icon" />
                <div>
                  <span className="bar" />
                </div>
              </div>
            )}
          </ReactSlick>
        </div>
        <div className="mainSliderHolder" data-testid="product-slider">
          {selectedLabels.length > 0 && (
            <ProductLabels
              labels={selectedLabels}
              discountPercentage={parseInt(discountPercentage, 10)}
              isProductPage
              extraClasses={arrayToString(BFCondition)}
            />
          )}
          <ReactSlick
            className="mainSlider"
            afterChange={current => {
              this.setState({ activeSlide: current });
              this.slider2.current.slickGoTo(current);
            }}
            asNavFor={this.state.nav2}
            ref={this.slider1}
            dots={false}
            infinite={false}
            arrows={false}
            speed={200}
            slidesToShow={1}
            slidesToScroll={1}
            lazyLoad
          >
            {images.gallery.map((item, i) => {
              return (
                <div className="" key={item.thumb}>
                  <ReactImageMagnify
                    {...{
                      hoverDelayInMs: 50,
                      enlargedImagePortalId: 'zoomedPic',
                      enlargedImageContainerDimensions: {
                        width,
                        height: '100%'
                      },
                      lensStyle: {
                        background: 'hsla(0, 0%, 100%, .3)',
                        border: '1px solid #ccc',
                        cursor: 'zoom-in'
                      },
                      shouldUsePositiveSpaceLens: true,
                      smallImage: {
                        width: this.props.general.isSmallDesktop ? 458 : 655,
                        height: this.props.general.isSmallDesktop ? 458 : 655,
                        alt: `${title} ${i}`,
                        isFluidWidth: false,
                        src: item.image,
                        srcSet: `${item.image} 1x, ${item.image_2x} 2x`,
                        onLoad: () => this.handleFirstPicLoaded(i)
                      },
                      largeImage: {
                        alt: `${title} ${i} large`,
                        src: item.image_2x,
                        width: 1200,
                        height: 1200
                      }
                    }}
                  />
                </div>
              );
            })}
            {/* {video_file ? (
              <div
                onClick={this.stopPropagation}
                style={{ paddingBottom: '100%', height: 0 }}
                role="button"
                tabIndex="-1"
              >
                <div style={style} className="videoWrapper">
                // eslint-disable-next-line jsx-a11y/media-has-caption
                  <video
                    title="product video"
                    src={video_file}
                    width={640}
                    height={360}
                    frameBorder={0}
                    style={{
                      position: 'absolute',
                      width: '100%',
                      height: '100%',
                      left: 0,
                    }}
                    controls
                    autoPlay
                  />
                </div>
              </div>
            )
            :
            (<div />)
          } */}
            {videos && videos.length > 0 && (
              <div
                onClick={this.stopPropagation}
                style={{ paddingBottom: '100%', height: 0 }}
                role="button"
                tabIndex="-1"
              >
                <div style={style} className="videoWrapper">
                  <iframe
                    title="product video"
                    src={videos[0].link}
                    width={640}
                    height={360}
                    frameBorder={0}
                    style={{
                      position: 'absolute',
                      width: '100%',
                      height: '100%',
                      left: 0
                    }}
                    allowFullScreen
                  />
                </div>
              </div>
            )}
          </ReactSlick>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ app, general, gallery }) => {
  return { app, general, gallery };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ ...galleryActions, ...overlayActions }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(SlickComponent);
